import { useState } from 'react';
import { login } from '@/utils/adminStore';

interface Props {
  onLoginSuccess: () => void;
}

export default function LoginForm({ onLoginSuccess }: Props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!username.trim() || !password.trim()) {
      setError('请输入用户名和密码');
      return;
    }

    setLoading(true);

    try {
      await login(username.trim(), password);
      onLoginSuccess();
    } catch {
      setError('用户名或密码错误');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-gray flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-brand-light">
            <i className="ri-shield-check-line text-2xl text-brand-dark" />
          </div>
          <h1 className="text-xl font-bold text-brand-deep">内容管理平台</h1>
          <p className="text-sm text-gray-400 mt-1">登录以管理网站内容</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-6 border border-brand-light/50">
          {error && (
            <div className="mb-4 px-4 py-2.5 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600 flex items-center gap-2">
              <i className="ri-error-warning-line" />
              {error}
            </div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium text-brand-deep mb-1.5">
              用户名
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="请输入用户名"
              className="w-full px-4 py-2.5 text-sm rounded-lg border border-brand-light bg-brand-gray text-brand-deep placeholder:text-gray-300 focus:outline-none focus:border-brand-warm transition-colors"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-brand-deep mb-1.5">
              密码
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
              className="w-full px-4 py-2.5 text-sm rounded-lg border border-brand-light bg-brand-gray text-brand-deep placeholder:text-gray-300 focus:outline-none focus:border-brand-warm transition-colors"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 px-4 bg-brand-deep text-white text-sm font-medium rounded-lg hover:bg-brand-dark disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            {loading && <i className="ri-loader-4-line animate-spin" />}
            {loading ? '登录中...' : '登 录'}
          </button>
        </form>
      </div>
    </div>
  );
}